import React, { useState } from "react";
import { Tabs, Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import "./TradeRoom.css"; // we'll add smooth animation CSS
import TradeTable from "./TradeTable";

const { TabPane } = Tabs;

const SmoothAccordionTabs = () => {
    const [collapsed, setCollapsed] = useState(true);
    // trade table colums
    const columns = [
        { title: "Pair", dataIndex: "name" },
        { title: "Qty", dataIndex: "quantity", align: "right" },
        { title: "Used Margin", dataIndex: "margin", align: "center" },
        { title: "Open Price", dataIndex: "open", align: "center" },
        { title: "LTP", dataIndex: "current", align: "center" },
        { title: "TP", dataIndex: "takeProfit", editable: true, align: "center" },
        { title: "SL", dataIndex: "stopLoss", editable: true, align: "center" },
        {
            title: "Net P/L",
            dataIndex: "pnl",
            render: (text) => (
                <span style={{ color: text > 0 ? "limegreen" : "red" }}>
                    {text > 0 ? `+$${text}` : `-$${Math.abs(text)}`}
                </span>
            )
            , align: "center"
        }, {
            title: "",
            dataIndex: "closepnl"
        }

    ];


    const data = [
        {
            key: "1",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/gold-bars.png" alt="gold-bars" />
                Gold
            </div>,
            quantity: null,  // not shown in image
            margin: "$3,785.79",
            open: 3785.790,
            current: 3771.590,
            takeProfit: "Add",
            stopLoss: "Add",
            pnl: -66.23,
            totalPnl: -776.23,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "1",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/gold-bars.png" alt="gold-bars" />
                Gold
            </div>,
            quantity: null,  // not shown in image
            margin: "$3,785.79",
            open: 3785.790,
            current: 3771.590,
            takeProfit: "Add",
            stopLoss: "Add",
            pnl: -66.23,
            totalPnl: -776.23,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        }, {
            key: "1",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/gold-bars.png" alt="gold-bars" />
                Gold
            </div>,
            quantity: null,  // not shown in image
            margin: "$3,785.79",
            open: 3785.790,
            current: 3771.590,
            takeProfit: "Add",
            stopLoss: "Add",
            pnl: -66.23,
            totalPnl: -776.23,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },


    ];


    return (
        <Tabs
            defaultActiveKey="margin"
            type="card"
            tabBarExtraContent={{
                right: (
                    <div
                        onClick={() => setCollapsed(!collapsed)}
                        style={{ cursor: "pointer", color: "#aaa", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4 }}
                    >
                        <span>{!collapsed ? "Hide positions" : "Show positions"}</span>
                        {!collapsed ? <DownOutlined /> : <UpOutlined />}
                    </div>
                ),
            }}
            className="trade-tab"
        >
            <TabPane tab={
                <div className="display-1 tab-head-txt">
                    Margin (5)
                    <div>
                        -$ 2,227.34
                    </div>
                </div>
            } key="margin">
                <div className={`accordion-content ${collapsed ? "collapsed" : "expanded"}`}>
                    <TradeTable columns={columns} data={data} scroll={{ y: 170 ,x:800}} className={"trade-table"} />
                </div>
            </TabPane>
            {/* <TabPane tab="Positions" key="positions">
                <div className={`accordion-content ${collapsed ? "collapsed" : "expanded"}`}>
                </div>
            </TabPane>
            <TabPane tab="Orders" key="orders">
                <div className={`accordion-content ${collapsed ? "collapsed" : "expanded"}`}>
                </div>
            </TabPane> */}
        </Tabs>
    );
};

export default SmoothAccordionTabs;
